/* eslint-disable */

import React, { useState } from 'react';
import { Card, CardContent, Typography, CardActionArea, Chip, IconButton, Collapse, Divider, Grid, Box } from '@material-ui/core';
import { useStyles } from './DiscountCardStyles';

import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import StarsIcon from '@material-ui/icons/Stars';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';

interface DiscountAndBoxes {
  boxesTo:  number | null;
  boxesFrom:  number | null;
  discountPercentage: number;
  isBiggestDiscount: boolean;
}

interface DiscountCardProps {
  index: number,
  product: {
    name: string;
    presentation: string;
    discountType: string;
    discountValue: number;
    biggestDiscount?: DiscountAndBoxes;
    otherDiscounts?: DiscountAndBoxes[];
  }
}

const DiscountCard: React.FC<DiscountCardProps> = ({ product, index }) => {
  const [selectedProductCard, setSelectedProductCard] = useState<number | null>(null);
  const classes = useStyles();

  return (
    <Card key={index} className={classes.productCard}>
      <CardActionArea onClick={() => setSelectedProductCard(selectedProductCard === index ? null : index)}>
        <CardContent className={classes.productCardContent}>
          <Box>
            <LocalHospitalIcon style={{ fontSize: 40, marginRight: '10px' }} />
          </Box>
          <Box className={classes.productDetails}>
            <Typography variant="subtitle1" component="div">
              {product.name} {product.presentation}
            </Typography>
          </Box>
          <Box className={classes.discountActions}>
            <Chip
              label={
                <Box className={classes.chipInnerContent}>
                  <Box className={classes.chipLabelContent}>
                    <Typography variant="caption" className={classes.discountText}>{product.discountValue}% <strong>OFF</strong></Typography>
                    <Typography variant="caption" className={classes.discountRule}>
                      {product.biggestDiscount?.boxesTo && product.biggestDiscount.boxesTo > 1
                        ? 'Kit com ' + product.biggestDiscount.boxesTo + ' Caixas'
                        : 'Uma Caixa'}
                    </Typography>
                  </Box>
                  {product.biggestDiscount?.isBiggestDiscount && (
                    <StarsIcon className={classes.starIcon} />
                  )}
                </Box>
              }
              className={classes.discountChip}
            />
            <IconButton>
              {selectedProductCard === index ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            </IconButton>
          </Box>
        </CardContent>
      </CardActionArea>

      <Collapse in={selectedProductCard === index} timeout="auto" unmountOnExit>
        <Box className={classes.expandedDiscountSection}>
          <Divider />
          <Typography variant="overline" display="block" gutterBottom>
            DESCONTOS E REGRAS
          </Typography>
          <Grid container spacing={2}>
            {product.otherDiscounts?.map((discount, subIndex) => (
              <Grid item key={subIndex}>
                <Chip
                  label={
                    <Box className={classes.chipInnerContent}>
                      <Box className={classes.chipLabelContent}>
                        <Typography variant="caption" className={classes.discountText}>{discount.discountPercentage}% <strong>OFF</strong></Typography>
                        <Typography variant="caption" className={classes.discountRule}>
                        {discount?.boxesTo && discount.boxesTo > 1
                          ? 'Kit com ' + discount.boxesTo + ' Caixas'
                          : 'Uma Caixa'}
                    </Typography>
                      </Box>
                      {discount.isBiggestDiscount && (
                        <StarsIcon className={classes.starIcon} />
                      )}
                    </Box>
                  }
                  className={classes.discountChip}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Collapse>
    </Card>
  );
};

export default DiscountCard;
